import React from 'react';
import { Link } from 'react-router-dom';
import { ListChecks, ArrowRight } from 'lucide-react';
import { IconBadge } from '../DarkUI';
import { text, border, brand, radius, typography } from '../design-system/tokens';

// KIQ Assistant — Fase 4 — Recommended Actions. `actions` viene del
// Intelligence Engine (backend/services/kiq/actionMapper.js) — cada acción
// ya trae una `destination.route` REAL (verificada contra App.js, nunca
// inventada aquí). El <Link> de react-router navega a esa ruta; Layout.js
// ya cierra el panel de KIQ automáticamente al cambiar de ruta (mismo
// efecto que cierra el drawer de navegación), así que no hace falta lógica
// nueva de cierre aquí.
export default function KIQActions({ actions = [] }) {
  return (
    <section style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '7px' }}>
        <ListChecks size={14} color="#6FE3D2" />
        <h2 style={{ ...typography.title, color: text.primary, margin: 0 }}>Acciones recomendadas</h2>
      </div>
      {actions.length === 0 ? (
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', padding: '12px', border: `1px solid ${border.default}`, borderRadius: radius.md, background: 'var(--card-alt)' }}>
          <IconBadge icon={ListChecks} color={brand.kiqPurple} size={26} iconSize={13} />
          <div style={{ minWidth: 0 }}>
            <div style={{ ...typography.bodySmall, color: text.secondary }}>No hay acciones recomendadas por ahora.</div>
            <div style={{ fontSize: '11px', color: text.muted, marginTop: '3px', lineHeight: 1.4 }}>Las acciones aparecerán aquí cuando KIQ detecte una oportunidad o riesgo.</div>
          </div>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          {actions.map((action) => (
            <Link
              key={action.id}
              to={action.destination.route}
              className="kiq-focusable"
              style={{
                display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '10px',
                padding: '10px 12px', border: `1px solid ${border.default}`, borderRadius: radius.md,
                background: 'var(--card)', textDecoration: 'none',
              }}
            >
              <div style={{ minWidth: 0 }}>
                <div style={{ fontSize: '13px', fontWeight: 700, color: text.primary }}>{action.title}</div>
                <div style={{ fontSize: '12px', color: text.muted, marginTop: '2px', lineHeight: 1.4 }}>{action.summary}</div>
              </div>
              <span style={{ display: 'flex', alignItems: 'center', gap: '4px', flexShrink: 0, fontSize: '11.5px', fontWeight: 700, color: brand.kiqBlue }}>
                {action.destination.label} <ArrowRight size={13} aria-hidden="true" />
              </span>
            </Link>
          ))}
        </div>
      )}
    </section>
  );
}
